import { processApiResponse, tamarackAPI } from "./Tamarack";

export const BookingDataAPI = {
    async validateBooking(AppID) {
        const path = `aspire/${AppID}/validate`;
        const response = await tamarackAPI.get(path);
        return processApiResponse(response, "get", path);
    },

    async generalSequenceBooking(AppID, sequence) {
        const path = `aspire/${AppID}/${sequence}`;
        const response = await tamarackAPI.get(path);
        return processApiResponse(response, "get", path);
    },
    async getCustomSettings() {
        const path = `customsettings/aspire`;
        const response = await tamarackAPI.get(path);
        return processApiResponse(response, "get", path);
    },

};
